module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3n1n2n-a39b460ed48d81cc138d05899cdabbf0.svg";